/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminQuoteSummaryDto } from './AdminQuoteSummaryDto';
import {
    AdminQuoteSummaryDtoFromJSON,
    AdminQuoteSummaryDtoFromJSONTyped,
    AdminQuoteSummaryDtoToJSON,
    AdminQuoteSummaryDtoToJSONTyped,
} from './AdminQuoteSummaryDto';

/**
 * 
 * @export
 * @interface GetAdminQuoteListResponseDto
 */
export interface GetAdminQuoteListResponseDto {
    /**
     * 
     * @type {number}
     * @memberof GetAdminQuoteListResponseDto
     */
    totalCount: number;
    /**
     * 
     * @type {Array<AdminQuoteSummaryDto>}
     * @memberof GetAdminQuoteListResponseDto
     */
    items: Array<AdminQuoteSummaryDto>;
}

/**
 * Check if a given object implements the GetAdminQuoteListResponseDto interface.
 */
export function instanceOfGetAdminQuoteListResponseDto(value: object): value is GetAdminQuoteListResponseDto {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetAdminQuoteListResponseDtoFromJSON(json: any): GetAdminQuoteListResponseDto {
    return GetAdminQuoteListResponseDtoFromJSONTyped(json, false);
}

export function GetAdminQuoteListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminQuoteListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(AdminQuoteSummaryDtoFromJSON)),
    };
}

export function GetAdminQuoteListResponseDtoToJSON(json: any): GetAdminQuoteListResponseDto {
    return GetAdminQuoteListResponseDtoToJSONTyped(json, false);
}

export function GetAdminQuoteListResponseDtoToJSONTyped(value?: GetAdminQuoteListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(AdminQuoteSummaryDtoToJSON)),
    };
}

